module.exports = __webpack_public_path__ + "static/img/newimg5.d96c20c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newimg5.png
// module id = tJkA
// module chunks = 1